<template>
  <b-container fluid>
    <!-- User Interface controls -->
    <b-row>
      <b-col md="4" class="my-1 ml-0">

      </b-col>
      <b-col sm="4"></b-col>
      <b-col md="4" class="my-1">
        <b-form-group
            label="Filter"
            label-cols-sm="2"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <br>
    <!-- Main table element -->
    <b-table
        show-empty
        small
        striped
        stacked="md"
        :items="account.beneficiaries"
        :busy="isBusy"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
    >

      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>



      <template v-slot:cell(serial)="row">
        {{ row.index + 1 }}
      </template>

      <template v-slot:cell(actions)="row">
        <b-button size="xs" @click="row.toggleDetails">
          {{ row.detailsShowing ? 'Hide' : 'Show' }} Account
        </b-button>

        <b-button class="ml-1" size="xs" @click="openSendMoneyModal(row.item)">
          Send Money
        </b-button>
      </template>

      <template v-slot:row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>
    </b-table>

    <b-row>
      <b-col md="3" class="my-1 ml-0">
        <b-form-group
            label="Per page"
            label-cols-sm="6"
            label-cols-md="4"
            label-cols-lg="3"
            label-align-sm="right"
            label-size="sm"
            label-for="perPageSelect"
            class="mb-0"
        >
          <b-form-select
              v-model="perPage"
              id="perPageSelect"
              size="sm"
              :options="pageOptions"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="5"></b-col>
      <b-col sm="4" md="4" class="my-1 mr-0">
        <b-pagination
            v-model="currentPage"
            :total-rows="account.beneficiaries.length"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>

    <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal>
    <b-modal :hide-header="true" id="singleFt" :hide-footer="true" :centered="true">
      <div class="modal-body">
        <a href="#" role="button" class="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" @click="hide('singleFt')">&times;</span>
        </a>

        <div>
          <h4>Initiate Single Transfer</h4>
          <p class="tx-color-03">Send Money To Beneficiary</p>
          <b-form @submit.prevent="sendMoneyToBeneficiary">

              <b-form-group
                            label="Benefeciary Name:"
                            class="form-group"
                            label-for="amount"
                            description="Beneficiary Name">
                <b-form-input
                    id="craccountname"
                    v-model="this.beneficiary.accountname"
                    type="text"
                    readonly
                ></b-form-input>
              </b-form-group>


            <b-form-group
                label="Amount:"
                class="form-group"
                label-for="amount"
                description="amount to be sent to beneficiary.">
              <b-form-input
                  id="amount"
                  v-model="singleft.amount"
                  type="number"
                  step="0.01"
                  required
                  placeholder="Enter Amount">
              </b-form-input>

            </b-form-group>


            <b-form-group class="form-group" label="Debit Account:">
              <b-form-select v-model="singleft.debit" :options="account.accountoption">
                <template v-slot:first>
                  <option value="">-- none --</option>
                </template>
              </b-form-select>
            </b-form-group>



            <b-form-group
                label="Narration:"
                class="form-group"
                label-for="narration"
                description="Enter Narration">
              <b-form-input
                  id="narration"
                  v-model="singleft.narration"
                  type="text"
                  required
                  placeholder="Enter Narration"
              ></b-form-input>

            </b-form-group>



            <base-button
                class="mt-3"
                :loading="ft.ftLoading"
                title="Push to Queue"
            ></base-button>


          </b-form>


        </div>
      </div><!-- modal-body -->
    </b-modal>

  </b-container>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import BaseButton from "@/components/button/BaseButton";

    export default {
        props:['isBusy', 'accounts'],
        name: 'BeneficiaryTable',
        components: {BaseButton},
        data() {
            return {
                totalRows: 1,
                currentPage: 1,
                perPage: 5,
                pageOptions: [5, 10, 15, 20],
                sortBy: '',
                sortDesc: false,
                beneficiary : {},
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                },
                singleft: {},
                accoption: [],
                items: [],

                fields: [
                    { key: 'serial',   label: 'Serial', sortable: true, class: 'text-left' },
                    { key: 'accountname',   label: 'Account Name', sortable: true, class: 'text-left' },
                    { key: 'accountnumber',   label: 'Account Number', sortable: true, class: 'text-left' },
                    { key: 'bankname',   label: 'Bank Name', sortable: true, class: 'text-left' },
                    { key: 'actions', label: 'Actions' }
                ],
            }
        },
        computed: {
            getAccounts() {
                // Create an options list from our fields
                return this.accounts;
            },
            allaccounts: function () {
                return this.$store.state.account.allAccounts;
            },
            ...mapState([
                'ft',
                'auth',
                'customer',
                'account'
            ]),
          ...mapGetters({
            beneficiaryOption: 'account/beneficiaryOptions',
          })
        },
        methods: {
            openSendMoneyModal: function (item){
              this.beneficiary = item
              console.log(item)
              this.$bvModal.show('singleFt')
            },
            sendMoneyToBeneficiary: async function (){
              this.singleft = {
                craccountname: this.beneficiary.accountname,
                creditaccount: this.beneficiary.accountnumber,
                creditbankname: this.beneficiary.bankname,
                creditbankcode: this.beneficiary.bankcode,
                username: this.auth.response.username,
                accountname : this.singleft.debit.accountname,
                amount : this.singleft.amount,
                accountnumber : this.singleft.debit.accountnumber,
                customerid: this.auth.response.customerid,
                narration: this.singleft.narration,
                source: 'WEB',
                saveben: false
              }
              console.log(this.singleft)
              let resp = await this.$store.dispatch("ft/singleft", this.singleft, {root: true});
              resp.responsecode === '00'? this.$bvModal.hide('singleFt') : '';
              this.$swal({
                title: resp.responsecode === '00'? 'Success' : 'Warning',
                text: resp.responsemessage,
                icon: resp.responsecode === '00'? 'success' : 'warning',
                showCancelButton: false,
                confirmButtonText: 'Ok'
              });
            },
            info(item, index, button) {
                this.infoModal.title = `Row index: ${index}`;
                this.infoModal.content = JSON.stringify(item, null, 2)
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            resetInfoModal() {
                this.infoModal.title = '';
                this.infoModal.content = ''
            },
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1
            },
            deleteTran(_id){
                let items = this.ft.transactions;
                items.splice(_id,1);
                this.$store.commit("ft/updateTransactions", items)
            }
        },
        mounted() {
           this.accoption =  this.accounts.map(acc => acc.accountno + ' ' + acc.availablebalance);
        }
    }
</script>
